export const FINANCIALS_FEATURE_NAME = 'Financials';
export const FINANCIALS_URL = 'financials';
export const FINANCIALS_ICON_FILE_PATH = 'assets/img/Financials-Icon-White.png';
